import { Box } from "@mui/material";
import { TabPanelProps } from "../../../../types/types";

const TabPanel: React.FC<TabPanelProps> = (props) => {
    const { children, value, index, className, ...other } = props;
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            className={className}
            {...other}
        >
            {value === index && children}
        </Box>
    );
};

export default TabPanel;